import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "../supabase";
import { useEffect, useState } from "react";

function Protected({ children }) {
  const location = useLocation();

  const [session, setSession] = useState(undefined);
  const [ready, setReady] = useState(false); // 🔥 هذا السر

  useEffect(() => {
    const init = async () => {
      const { data } = await supabase.auth.getSession();
      setSession(data.session);
      setReady(true); // 🔥 لا تسمح بالتحقق قبل هذا
    };

    init();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        setReady(true);
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  // ⏳ انتظر الجلسة بالكامل
  if (!ready) {
    return <div>Loading...</div>;
  }

  // ❌ غير مسجل
  if (!session || sessionStorage.getItem("passwordRecoveryInProgress") === "true") {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }
console.log("🔥 ENTER LOGIN PAGE");
  // ✅ مسجل
  return children;
}

export default Protected;
